const excerpt = (string, max = 30) => {
    return typeof string === 'string'
        ? string.length > max
            ? string.slice(0, max) + ' ...'
            : string

        : ''
}

export default excerpt